import styled from "styled-components"
import Section from "../../../components/common/sections/section.component"
import { SubmenuItem as SubmenuItemType } from "../../types/menu.interface"
import {
  annotationStyles,
  gridSpacing,
} from "../../../components/common/general-styles.component"
import { NeutralTextLink } from "../../../ui/components/link/link.component"

export const MenuColumn = styled.ul<{ items: SubmenuItemType[] }>`
  width: 50%;
  padding: 0;
  margin-top: 0;
  list-style: none;

  @media (min-width: ${({ theme }) => theme.breakpoint.mobileHorizontal}px) {
    width: ${({ items }) => (items.length > 4 ? `33.33%` : `25%`)};
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    width: ${({ items }) => (100 / items.length).toFixed(3)}%;
  }

  li {
    line-height: 1em;
    margin: 0 0 16px 0;
    max-width: 135px;

    &:first-of-type {
      line-height: ${32 / 14}em;
      margin-bottom: 10px;
    }
  }
`

export const SubmenuItem = styled(NeutralTextLink)`
  ${annotationStyles};
  line-height: inherit;
  color: ${({ theme }) => theme.color.textFooter};
  font-size: ${14 / 16}rem;

  @media (min-width: 640px) {
    line-height: inherit;
  }

  &:hover {
    opacity: 1;
  }
`

export const Menu = styled.nav`
  grid-area: Menu;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  @media (max-width: ${({ theme }) => theme.breakpoint.tablet - 1}px) {
    // The 40px need to fit the nav into the section component container width.
    max-width: calc(100vw - 40px);
    margin-top: 30px;
  }
`

export const FooterSection = styled(Section)<{ items: SubmenuItemType[] }>`
  ${gridSpacing};
  grid-row-gap: 20px;
  grid-template-columns: auto;
  margin-top: 90px;
  margin-bottom: calc(var(--grid-spacing) / 2);
  grid-template-areas: "Social" "Menu" "Language" "Copyrights";

  @media (min-width: 768px) {
    grid-template-columns: 1fr 3fr;
    grid-template-areas: "Social Menu" "Currency Currency" "Language Language" "Copyrights Copyrights";
    margin-top: 60px;
  }

  @media (min-width: 960px) {
    grid-template-columns: ${({ items }) =>
      items.length > 4 ? `1fr 3fr` : `2fr 3fr`};
  }
`
